module.exports = __webpack_public_path__ + "static/media/taxii.09497ad2.png";